// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".landing-freelance-universe #offers{padding:0;gap:1rem}.landing-freelance-universe #offers .card-header{min-height:72px}.landing-freelance-universe #offers ul.keywords{gap:0.5rem}.landing-freelance-universe #offers ul.keywords li{list-style:none;background-color:#f39b43;border-radius:.2rem;color:#fff;font-size:1.1rem}\n", ""]);
// Exports
module.exports = exports;
